import React, {Component} from 'react';
import {Frame,FooterHelp,Link} from "@shopify/polaris";
import NavigationPanel from "./navigation";
import NavigationTour from '../../shared/Tour/NavigationTour';
import TopBarPanel from "./topbar";
import {globalState} from "../../services/globalstate";
import {Redirect, Route, Switch, withRouter} from "react-router-dom";
import Profiles from "../Profiles/profiles";
import Activities from "../Activities/activities";
import Orders from "../Orders/order";
import ImportUpload from "../ImportUpload/importupload";
import Products from "../Products/products";
import Help from "../Help/help";
import AccountsPanel from "../Accounts/accounts";

import Dashboard from "../Dashboard/dashboard";
import {requests} from "../../services/request";
import {isUndefined} from "util";
import Plans from "../Plan/plans";
import ReportAnIssue from "../Help/report-issue";
import RecentActivities from "../Activities/recentactivites";
import Configuration from "../Configurations/configuration";
import CustomItemIdmain from "../Configurations/CustomItemId";
import TemplateModifier from "../../templates/templateModifier";
import PaymentShippingReturn from "../../templates/paymentShippingReturntemplate";
import TemplateList from "../TemplateList/templatelist";
import BusinessPolicy from "../BusinessPolicy/businesspolicy";
import CreateProfile from "../Profiles/createProfile";
import ViewProfile from "../Profiles/ViewProfile";
import ViewProducts from "../Products/view-products";
import ViewOrder from "../Orders/view-order";
import CancelmainOrder from "../Orders/cancel-main-order";
import failedProducts from "../Products/failed-products";
import newProducts from "../Products/new-products";
import BillingHistory from "../Plan/billing-history";
import FooterBar from "./footerbar";
import bulkUpdate from "../Products/bulkupdate";
import OrderEnquiry from "../Orders/order_enquiry";
import Registrations from "../Registration/registrations";
import Ebaymessages from "../eBayMessages/ebaymessages";
import Taxtables from "../Products/taxtables";
import NewProducts from '../Products/NewProducts';
import NewOrders from '../Orders/NewOrders';
import NewBusinessPolicy from '../BusinessPolicy/newbusinesspolicy';
import NewProfiles from '../Profiles/NewProfile';
import NewTemplateList from '../TemplateList/NewTemplateList';
import NewViewProducts from '../Products/NewViewProducts';
import {connect} from "react-redux";
import { json } from '../../environments/static-json';
import { getMethod, postMethod } from './requestHelper';

class Panel extends Component {
  constructor(props){
    super(props);
    this.state={
      showMobileNavigation:false,
      registration_complete:true,
      show_footer: false,
      footer_message: '',
      isNavigationOpen:false,
      userId:0,
      tourOpen:false,
    };
    this.checkStepCompleted();
    this.getFooterMessage();
    this.getUserId();
  }

  getTrigger = () => {
    if(sessionStorage.getItem("shopifyAccount")) {
      const wind = window;
      const $zoho = wind.$zoho || {};
      const salesiq = $zoho.salesiq;
      const sourceData = {
        ...JSON.parse(sessionStorage.getItem("shopifyAccount")),
      };
      const email = sessionStorage.getItem("email") ? sessionStorage.getItem("email") : "" ;
      const fullName = sessionStorage.getItem("full_name") ? sessionStorage.getItem("full_name") : "";
      const contactNumber = sessionStorage.getItem("mobile") ? sessionStorage.getItem("mobile") : "";
      const storeUrl = sourceData && sourceData.shops && sourceData.shops[0] && sourceData.shops[0].shop_url ? sourceData.shops[0].shop_url : "" ;
      // const email = 'test'
      // const fullName = 'utkarsh'
      // const contactNumber = '123'
      // const storeUrl = 'test123'

      // const $zoho = wind.$zoho || {};
      // const salesiq = $zoho.salesiq;

      salesiq && salesiq.visitor && salesiq.visitor.name(fullName);
      salesiq && salesiq.visitor && salesiq.visitor.email(email);
      salesiq && salesiq.visitor && salesiq.visitor.contactnumber(contactNumber);
      salesiq && salesiq.visitor && salesiq.visitor.info({
        Store_URL: storeUrl,
        Payment_Status:
        // "Free",
          sessionStorage.getItem("planType") === "Unpaid" ? "Free" : "Paid",
        "App Name": "eBay Integration Single",
        FrameWork: "Shopify",
      });
    }

    // const win = window;
    // if(sessionStorage.getItem('shopify_id')) {(async () => {
    //   let payload = {
    //     get: "getRestoreId",
    //   };
    //   // Fetch restoreId in your database
    //   const restoredData = await getMethod('ebayV1/get/getRestoreId', payload);
    //   // console.log('restoredData', restoredData);
    //   const { data } = restoredData;
    //   let user = {};
    //   user = data[0];
    //   // var { email } = user;
    //   if (user) {
    //     const {
    //       firstName,
    //       lastName,
    //       phone,
    //       restoreId,
    //       phoneCountryCode,
    //       // status,
    //       email,
    //       website,
    //     } = user;
    //     let status = ""
    //     const planStatusData = await getMethod('frontend/app/getServiceCredits', { service_code: 'ebay_uploader' });
    //     if(planStatusData.success) {
    //       status = "Paid"
    //     } else {
    //       status = "Unpaid"
    //     }
    //     console.log("user", user);
    //     let userData = {
    //       // email: email ?? "",
    //     };
    //     if(email) {
    //       userData['email'] = email
    //     } else {
    //       userData['email'] = ""
    //     }
    //     var externalId = `${sessionStorage.getItem("userId")}_${email}`;
    //     win.fcWidgetMessengerConfig = {
    //       ...userData,
    //       externalId: externalId,
    //       // restoreId: restoreId ?? null,
    //     };
    //     if(restoreId) {
    //       win.fcWidgetMessengerConfig = {
    //         ...userData,
    //         externalId: externalId,
    //         restoreId: restoreId
    //       };
    //     } else {
    //       win.fcWidgetMessengerConfig = {
    //         ...userData,
    //         externalId: externalId,
    //         restoreId: ""
    //       };
    //     }
    //     const fwScript = document.querySelector(
    //       'script[src="//in.fw-cdn.com/30398529/224630.js"]'
    //     );
    //     if (!fwScript) {
    //       const script = document.createElement("script");
    //       script.src = "//in.fw-cdn.com/30398529/224630.js";
    //       script.setAttribute("chat", true);
    //       script.setAttribute(
    //         "widgetId",
    //         "122cf1fb-ad03-499f-ba84-2d80837cdad1"
    //       );
    //       document.body.appendChild(script);
    //     }
    //     // custom contact properties
    //     if(win.fwcrm && win.fwcrm.on && win.fcWidget && win.fcWidget.conversation && win.fcWidget.conversation.setConversationProperties) {
    //       win.fwcrm.on("widget:loaded", function () {
    //         win.fcWidget.conversation.setConversationProperties({
    //           cf_subscription:
    //             status !== "Unpaid" ? "Purchased" : "Not Purchased",
    //           cf_shop_url: website,
    //         });
    //       });
    //     }
    //     setTimeout(() => {
    //       (() => {
    //         if(win.fcWidget && win.fcWidget.user) {
    //           win.fcWidget.user.get(async function (resp) {
    //             console.log("response", resp, userData);
    //             const status = resp && resp.status,
    //               data = resp && resp.data;
    //             if (status !== 200) {
    //               await win.fcWidget.user.setProperties({
    //                 ...userData,
    //               });
    //               await win.fcWidget.conversation.setConversationProperties({
    //                 cf_subscription:
    //                   status !== "Unpaid" ? "Purchased" : "Not Purchased",
    //                 cf_shop_url: website,
    //               });
    //               await win.fcWidget.setExternalId(externalId);
    //               win.fcWidget.on("user:created", async function (resp) {
    //                 console.log("resprespresp", resp);
    //                 const status = resp && resp.status,
    //                   data = resp && resp.data;
    //                 if (status === 200) {
    //                   if (data.restoreId) {
    //                     let payload = {
    //                       freshchat_restore_id: data.restoreId,
    //                     };
    //                     // Update restoreId in your database
    //                     let { success, data: UpdateFreshChatIDAPIDtaa } =
    //                       await postMethod("ebayV1/get/saveRestoreId", payload);
    //                   }
    //                 }
    //               });
    //             }
    //           });
    //         }
    //       })();
    //     }, 2500);
    //   }
    // })();
    // } else {
    //   if(win.fcWidget) {
    //     win.fcWidget.destroy();
    //   }
    // }
  }

  getFooterMessage(){

   
      requests.getRequest('frontend/app/showFooter')
           .then(response =>{
          //   if(response.success) {
             this.setState({ show_footer: Object.keys(response.message).includes('footer'), footer_message: response.message.footer});
          //  }
          });
  }
  getUserId(){
    requests.getRequest('user/getDetails', undefined, false, true)
    .then(data => {
      if (data.success) {
        this.state.userId=data.data.id
        this.setState(this.state);
        localStorage.setItem("userID",data.data.id)        
      } 
    });
  }

  checkStepCompleted() {
    let path = '/App/User/Step';
    requests.getRequest('frontend/app/getStepCompleted', {path: path}).then(data => {
      if (data.success) {
        if (data.data !== null && !isUndefined(data.data)) {
          if(parseInt(data.data)<6){
            this.redirect('/auth/registration')
          }
          else{
            this.state.registration_complete=true;
            this.setState(this.state);
          }
        }
      }
      else{
        this.redirect('/auth/registration');
      }

    });

  }
  toggleState = (key) => {

    this.setState((prevState) => ({[key]: !prevState[key]}));

  };
  redirect(url){
    this.props.history.push(url);
  }

  handleTourOpen(flag){
    this.setState({tourOpen:flag})
  }
  render() {
    // if(sessionStorage.getItem('admin_login') === "false") {
      this.getTrigger()
    // }
    let { show_footer,  footer_message, activity} = this.state;
    const topBarMarkup = <TopBarPanel 
      toggleMobileNavigation={()=>{
        this.toggleState('showMobileNavigation')}} 
        logout={(url)=>{
      globalState.removeLocalStorage('auth_token');
      globalState.removeLocalStorage('user_authenticated');
      this.redirect("/auth/login")
    }}/>;
    const navigationMarkup = (
      <NavigationPanel navigationOpen={this.state.isNavigationOpen} handleTourOpen={this.handleTourOpen.bind(this)} tourOpen={this.state.tourOpen} element={document.getElementById("xyz")} show_footer={this.state.show_footer} userId={this.state.userId}/>
    );
    const footerMarkup = show_footer ? <FooterBar message={footer_message}/> : false;
    // const footerMarkup = true ? <FooterBar message={footer_message}/> : false;
    return (
      this.state.registration_complete &&
      <Frame topBar={topBarMarkup}
             navigation={navigationMarkup}
             globalRibbon={footerMarkup}
             showMobileNavigation={this.state.showMobileNavigation} 
             onNavigationDismiss={()=>{this.toggleState('showMobileNavigation')}}
      >
        <NavigationTour tourOpen={this.state.tourOpen} handleTourOpen={this.handleTourOpen.bind(this)} />
        <div id="xyz">
        <Switch>
          <Route exact path="/panel/" render={() => (
            <Redirect to="/panel/dashboard"/>
          )}/>
          <Route exact path='/panel/dashboard' component={Dashboard}/>
          <Route exact path='/panel/accounts' component={AccountsPanel}/>
         
          <Route exact path='/panel/help' component={Help}/>
          <Route exact path='/panel/help/report' component={ReportAnIssue}/>
          {/* <Route exact path='/panel/prevproducts' component={Products}/> */}
          <Route exact path='/panel/products' state={this.state.userId} component={NewProducts}/>
          {/* <Route exact path='/panel/products/view' component={ViewProducts}/> */}
          <Route exact path='/panel/products/view' component={NewViewProducts}/>
          <Route exact path='/panel/products/taxtables' component={Taxtables}/>
          <Route exact path='/panel/products/failed' component={failedProducts}/>
          <Route exact path='/panel/products/new' component={newProducts}/>
          /*<Route exact path='/panel/products/bulkupdate' component={bulkUpdate}/>*/
          <Route exact path='/panel/config' component={Configuration}/>
          <Route exact path='/panel/config/customItemId' component={CustomItemIdmain}/>
          <Route exact path='/panel/exhangestation' component={ImportUpload}/>
          {/* <Route exact path='/panel/prevorders' component={Orders}/> */}
          <Route exact path='/panel/orders' component={NewOrders}/>
          <Route exact path='/panel/orders/view' component={ViewOrder}/>
          <Route exact path='/panel/orders/enquiry' component={OrderEnquiry}/>
          <Route exact path='/panel/orders/cancelmainorder' component={CancelmainOrder}/>
          <Route exact path='/panel/plans' component={Plans}/>
          <Route exact path='/panel/plans/billing' component={BillingHistory}/>
          {/* <Route exact path='/panel/profiles' component={Profiles}/> */}
          <Route exact path='/panel/profiles' component={NewProfiles}/>
          <Route exact path='/panel/profiles/createprofile' component={CreateProfile}/>
          <Route exact path='/panel/profiles/viewprofile' component={ViewProfile}/>
          <Route exact path='/panel/activities' component={Activities}/>
          <Route exact path='/panel/activities/recent' component={RecentActivities}/>
          <Route exact path='/panel/template/business' component={PaymentShippingReturn}/>
          <Route exact path='/panel/ebayMessages' component={Ebaymessages}/>

          <Route exact path='/panel/template/modifier' component={TemplateModifier}/>
          {/* <Route exact path='/panel/template/prevlist' component={TemplateList}/> */}
          <Route exact path='/panel/template/list' component={NewTemplateList}/>
          {/* <Route exact path='/panel/businesspolicies/list' component={BusinessPolicy}/> */}
          <Route exact path='/panel/businesspolicies/list' component={NewBusinessPolicy}/>
          <Redirect from ="**" to="/panel/dashboard"/>
        </Switch>
        </div>
        
      </Frame>
    );
  }
}

const mapStateToProps = state => {
  let { activity } = state;
  return ({ activity    });
}

// export default withRouter(Panel);
export default connect(mapStateToProps)(withRouter(Panel));
